import { useState } from 'react';
import { HOST_URL } from '../../../../../actions/api';

const AccountTabs = ({mfa_auth, isCollaborator}) => {
  const [urlGet, setUrlGet] = useState(window.location.href)
  const [activeClass, setActiveClass] = useState('')
  const [urlGet1, setUrlGet1] = useState(window.location.href)

  const removeHash = () => {
    setUrlGet(`${HOST_URL}/widget/transactions`);
  }
  const removeHash_ = () => {
    setUrlGet1(`${HOST_URL}/widget/transactions`);
    setActiveClass('active')
  }
  return (
    <div className="subheader subheader_main fixed_subheader subheader-transparent dual_subheader"
      id="kt_subheader">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
          <ul id="accounts-nav" className="nav nav-tabs nav-tabs-space-lg flex-nowrap align-content-end nav-tabs-line nav-tabs-bold top_nav_tabs" role="tablist" >
            <li className="nav-item">
              <a className={`nav-link ${urlGet.includes('#connectedAccounts') ? '' : activeClass == "active" ? '' : 'active'}`} data-bs-toggle="tab" href="#accountInfo" onClick={(e) => removeHash()} > <span className="nav-text text-nowrap">Account Info</span> </a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ${activeClass}`} data-bs-toggle="tab" href="#productSubscriptions" onClick={(e) => removeHash_()} > <span className="nav-text text-nowrap"> Product Subscriptions </span> </a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ${urlGet.includes('#connectedAccounts') ? 'active' : null}`} data-bs-toggle="tab" href="#connectedAccounts" > <span className="nav-text text-nowrap"> Social Accounts </span> </a>
            </li>
            {mfa_auth==1 && !isCollaborator ? <li className="nav-item">
              <a className={`nav-link ${urlGet.includes('#MfaAuthenticator') ? 'active' : null}`} data-bs-toggle="tab" href="#MfaAuthenticator" > <span className="nav-text text-nowrap"> MFA Authenticator </span> </a>
            </li> : null}
          </ul>
        </div>
      </div>
    </div>
  )
}


export default AccountTabs;